import React from 'react';
import { SvgProps } from 'models/svg';

const ArrowUp = ({ className }: SvgProps) => {
  return (
    <svg className={className} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='0.5' y='0.5' width='23' height='23' rx='11.5' stroke='#E5E7EB' />
      <path
        d='M12.5391 6.89844L16.2891 10.6484C16.5703 10.9531 16.5703 11.4219 16.2891 11.7266C15.9844 12.0078 15.5156 12.0078 15.2109 11.7266L12.75 9.24219V17.9375C12.75 18.3594 12.4219 18.6875 12 18.6875C11.5781 18.6875 11.25 18.3594 11.25 17.9375V9.24219L8.78906 11.7266C8.48438 12.0078 8.01562 12.0078 7.71094 11.7266C7.42969 11.4219 7.42969 10.9531 7.71094 10.6484L11.4609 6.89844C11.7656 6.61719 12.2344 6.61719 12.5391 6.89844Z'
        fill='#222156'
      />
    </svg>
  );
};

export default ArrowUp;
